import React from 'react';
import {
  ArtTrackOutlined,
  ContactlessOutlined,
  LayersOutlined,
  MovieFilter,
  PermMediaOutlined,
  PostAdd,
} from '@material-ui/icons';
import IntlMessages from '../../../utils/IntlMessages';
import GroupIcon from '@material-ui/icons/Group';

const mediaMenus = {
  name: 'مدیریت فیلم‌ها',
  icon: <LayersOutlined />,
  type: 'collapse',
  children: [
    {
      name: 'لیست فیلم‌ها',
      icon: <PermMediaOutlined />,
      type: 'item',
      link: '/movie',
    },
    {
      name: 'بارگذاری و تبدیل فیلم‌ها',
      icon: <MovieFilter />,
      type: 'item',
      link: '/convert-list',
    },
  ],
};

export const movieManagerSidebarNavs = [
  {
    name: 'لیست فیلم‌ها',
    icon: <PermMediaOutlined />,
    type: 'item',
    link: '/movie',
  },
]

export const sidebarNavs = [
  {
    name: <IntlMessages id={'sidebar.main'} />,
    type: 'section',
    children: [mediaMenus],
  },
  {
    name: 'مدیریت محتوی',
    type: 'item',
    icon: <ArtTrackOutlined />,
    link: '/content',
  },
  {
    name: 'مدیریت اخبار',
    type: 'item',
    icon: <ContactlessOutlined />,
    link: '/news',
  },
  {
    name: 'مدیریت هنرمندان',
    type: 'item',
    icon: <GroupIcon />,
    link: '/manage-artist',
  },
  {
    name: 'لیست تسویه حساب ها',
    icon: <PermMediaOutlined />,
    type: 'item',
    link: '/finance',
  },
];

export const horizontalDefaultNavs = [
  {
    name: <IntlMessages id={'sidebar.main'} />,
    type: 'collapse',
    children: [
      {
        name: <IntlMessages id={'pages.samplePage'} />,
        type: 'item',
        icon: <PostAdd />,
        link: '/sample-page',
      },
    ],
  },
];

export const minimalHorizontalMenus = [
  {
    name: <IntlMessages id={'sidebar.main'} />,
    type: 'collapse',
    children: [
      {
        name: <IntlMessages id={'pages.samplePage'} />,
        type: 'item',
        icon: <PostAdd />,
        link: '/sample-page',
      },
    ],
  },
];
